

export default function License() 
{
	return (
		<h1 className="text-xl dark:text-white">This is License</h1>
		)
}